import { useState } from "react";

//DEPENDENCIES
import { AxiosError } from "axios";

//STYLES
import styles from "../NavBar.module.scss";

//UI COMPONENTES
import Button from "../../Button/Button";
import NavItemAccordion from "./NavItemAccordion";
import NavItemLink from "./NavItemLink";
import CallToActionCard from "../../CallToActionCard";

//UTILS
import { getNavItems, openExternal } from "../utils/utils";
import { useAppSelector } from "../../../store/hooks";
import { getAllariaMasRedirectUrl } from "../../../connectors/unifyApi";
import { isDev, onErrorGoToAllariaMas } from "../../../utils";
import { createSearchParams, useNavigate } from "react-router-dom";
import useFeatures from "../../../hooks/useFeatures";

const NavItems = ({
  toggleMobileDrawer,
}: {
  toggleMobileDrawer?: () => void;
}) => {
  const { navItemsContainer, navFooter } = styles;

  const [loadingRedirectButton, setLoadingRedirectButton] = useState(false);

  const { allariaMasLinkedAccount, user } = useAppSelector(
    (state) => state.authentication,
  );

  const navigate = useNavigate();

  const features = useFeatures();

  const navItems = getNavItems(user, features);

  const handleFeedbackButtonClicked = () => {
    navigate(
      {
        pathname: "ayuda",
        search: createSearchParams({ question: "testing_phase" }).toString(),
        hash: "testing_phase_input",
      },
      { replace: true },
    );
  };

  const handlegoToAllariaMas = async () => {
    setLoadingRedirectButton(true);

    try {
      const response = await getAllariaMasRedirectUrl();

      if (response.url) {
        openExternal(response.url, "_blank");
      } else {
        onErrorGoToAllariaMas();
      }
    } catch (error) {
      const errorCode =
        error && error instanceof AxiosError
          ? error?.response?.data?.code
          : null;

      onErrorGoToAllariaMas(errorCode);
    } finally {
      setLoadingRedirectButton(false);
    }
  };

  return (
    <div className={navItemsContainer}>
      <div>
        {navItems.map((itemProps) => {
          const { key, collapsableGroup } = itemProps;

          if (collapsableGroup) {
            return (
              <NavItemAccordion key={key} navItem={itemProps}>
                {collapsableGroup.items.map((collapsableNavItem) => {
                  return (
                    <NavItemLink
                      key={collapsableNavItem.key}
                      navItem={collapsableNavItem}
                      toggleMobileDrawer={toggleMobileDrawer}
                    />
                  );
                })}
              </NavItemAccordion>
            );
          }

          return (
            <NavItemLink
              key={key}
              navItem={itemProps}
              toggleMobileDrawer={toggleMobileDrawer}
            />
          );
        })}
      </div>

      <div className={navFooter}>
        {isDev && <CallToActionCard />}

        <Button text="Dar feedback" onPress={handleFeedbackButtonClicked} />

        {allariaMasLinkedAccount && (
          <Button
            text="Ir a Allaria+"
            onPress={handlegoToAllariaMas}
            isLoading={loadingRedirectButton}
          />
        )}
      </div>
    </div>
  );
};

export default NavItems;
